<template>
<div
	ref="modalRef"
	class="modal fade"
	tabindex="-1"
	aria-labelledby="modal-label"
	aria-hidden="true"
	data-bs-keyboard="false"
	:data-bs-backdrop="'static'"
>
	<div class="modal modal-lg modal-dialog modal-dialog-centered modal-dialog-scrollable modal-fullscreen-lg-down">
		<div class="modal-content px-5">
			<div class="modal-header px-5">
				<h1 class="modal-title fs-5">Створення нової станції</h1>
			</div>

			<div class="modal-body px-5">
			<Form
				@submit="onSubmit"
				@invalid-submit="console.log"
				:validation-schema="schema"
				:initial-values="formValues"
				v-slot="{ errors, meta: meta }"
			>
				<div class="row form-row">
					<div class="form-group col-auto input-min-width">
						<label>Назва&nbsp;*</label>
						<Field
							name="name"
							type="text"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors.name }"
						/>
						<div class="invalid-feedback">{{errors.name}}</div>
					</div>
				</div>

				<div class="row form-row">
					<div class="form-group col-auto">
						<label>Коротка назва</label>
						<Field
							name="short_name"
							type="text"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors.short_name }"
						/>
						<div class="invalid-feedback">{{errors.short_name}}</div>
					</div>
				</div>

				<div class="row form-row">
					<div class="form-group col-auto mt-2 input-min-width">
						<label>Експлуатуюча організація&nbsp;*</label>
						<Field
							name="org_id"
							as="select"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors.org_id }"
							:disabled="accountStore.organization.role == 'secondary'"
						>
							<option value="" disabled>Натисніть щоб обрати</option>
							<option
								v-for="org in organizations"
								:key="org._id"
								:value="org._id"
							>
								{{ org.title }}
							</option>
						</Field>
						<div class="invalid-feedback">{{errors.org_id}}</div>
					</div>
				</div>

				<div class="row form-row">
					<div class="form-group col-auto mt-2">
						<label>IP адреса станції&nbsp;*</label>
						<Field
							name="ip"
							type="text"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors.ip }"
						/>
						<div class="invalid-feedback">{{errors.ip}}</div>
					</div>
				</div>

				<div class="row mt-3">
					<div class="col-auto">
						<unit-icon unitType="modem" />
					</div>
					<h6 class="col my-auto py-auto px-0 fw-bolder">Модем</h6>
				</div>
				<div class="row form-row">
					<div class="form-group col-auto">
						<label>Версія модема&nbsp;*</label>
						<Field
							:name="`${Station.passportKeys.modemUnit.self}.${Station.passportKeys.modemUnit.unitVersion}`"
							as="select"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors[`${Station.passportKeys.modemUnit.self}.${Station.passportKeys.modemUnit.unitVersion}`] }"
						>
							<option value="" disabled>Натисніть щоб обрати</option>
							<template v-for="[key, value] of Object.entries(ModemUnit.versionNames)" :key="key">
								<option :value="key">{{ value }}</option>
							</template>
						</Field>
						<div class="invalid-feedback">{{errors[`${Station.passportKeys.modemUnit.self}.${Station.passportKeys.modemUnit.unitVersion}`]}}</div>
					</div>
				</div>
				<div class="row form-row">
					<div class="form-group col-auto mt-2">
						<label>Порт модема&nbsp;*</label>
						<Field
							:name="`${Station.passportKeys.modemUnit.self}.${Station.passportKeys.modemUnit.unitPort}`"
							type="number"
							class="form-control form-control-sm no-arrow"
							:class="{ 'is-invalid': errors[`${Station.passportKeys.modemUnit.self}.${Station.passportKeys.modemUnit.unitPort}`] }"
						/>
						<div class="invalid-feedback">{{errors[`${Station.passportKeys.modemUnit.self}.${Station.passportKeys.modemUnit.unitPort}`]}}</div>
					</div>
				</div>
				<div class="row form-row">
					<div class="form-group col-auto mt-2">
						<label>ModBus адреса модема&nbsp;*</label>
						<Field
							:name="`${Station.passportKeys.modemUnit.self}.${Station.passportKeys.modemUnit.unitModbusAddr}`"
							type="number"
							class="form-control form-control-sm no-arrow"
							:class="{ 'is-invalid': errors[`${Station.passportKeys.modemUnit.self}.${Station.passportKeys.modemUnit.unitModbusAddr}`] }"
						/>
						<div class="invalid-feedback">{{errors[`${Station.passportKeys.modemUnit.self}.${Station.passportKeys.modemUnit.unitModbusAddr}`]}}</div>
					</div>
				</div>

				<div class="row mt-3">
					<div class="col-auto">
						<unit-icon unitType="power" />
					</div>
					<h6 class="col my-auto py-auto px-0 fw-bolder">
						Силовий модуль
					</h6>
				</div>
				<div class="row form-row">
					<div class="form-group col-auto">
						<label>Версія силового модуля&nbsp;*</label>
						<Field
							:name="`${Station.passportKeys.powerUnit.self}.${Station.passportKeys.powerUnit.unitVersion}`"
							as="select"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors[`${Station.passportKeys.powerUnit.self}.${Station.passportKeys.powerUnit.unitVersion}`] }"
						>
							<option value="" disabled>Натисніть щоб обрати</option>
							<template v-for="[key, value] of Object.entries(PowerUnit.versionNames)" :key="key">
								<option :value="key">{{ value }}</option>
							</template>
						</Field>
						<div class="invalid-feedback">{{errors[`${Station.passportKeys.powerUnit.self}.${Station.passportKeys.powerUnit.unitVersion}`]}}</div>
					</div>
				</div>
				<div class="row form-row">
					<div class="form-group col-auto mt-2">
						<label>Порт силового модуля&nbsp;*</label>
						<Field
							:name="`${Station.passportKeys.powerUnit.self}.${Station.passportKeys.powerUnit.unitPort}`"
							type="number"
							class="form-control form-control-sm no-arrow"
							:class="{ 'is-invalid': errors[`${Station.passportKeys.powerUnit.self}.${Station.passportKeys.powerUnit.unitPort}`] }"
						/>
						<div class="invalid-feedback">{{errors[`${Station.passportKeys.powerUnit.self}.${Station.passportKeys.powerUnit.unitPort}`]}}</div>
					</div>
				</div>
				<div class="row form-row">
					<div class="form-group col-auto mt-2">
						<label>ModBus адреса силового модуля&nbsp;*</label>
						<Field
							:name="`${Station.passportKeys.powerUnit.self}.${Station.passportKeys.powerUnit.unitModbusAddr}`"
							type="text"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors[`${Station.passportKeys.powerUnit.self}.${Station.passportKeys.powerUnit.unitModbusAddr}`] }"
						/>
						<div class="invalid-feedback">{{errors[`${Station.passportKeys.powerUnit.self}.${Station.passportKeys.powerUnit.unitModbusAddr}`]}}</div>
					</div>
				</div>

				<div class="row mt-3">
					<div class="col-auto">
						<unit-icon unitType="service" />
					</div>
					<h6 class="col my-auto py-auto px-0 fw-bolder">
						Сервісний модуль
					</h6>
				</div>
				<div class="row form-row">
					<div class="form-group col-auto">
						<label>Версія сервісного модуля&nbsp;*</label>
						<Field
							:name="`${Station.passportKeys.serviceUnit.self}.${Station.passportKeys.serviceUnit.unitVersion}`"
							as="select"
							class="form-control form-control-sm"
							:class="{ 'is-invalid': errors[`${Station.passportKeys.serviceUnit.self}.${Station.passportKeys.serviceUnit.unitVersion}`] }"
						>
							<option value="" disabled>Натисніть щоб обрати</option>
							<option
								v-for="version in Object.values(ServiceUnit.versions)"
								:key="version"
								:value="version"
							>
								{{ ServiceUnit.versionNames[version] }}
							</option>
						</Field>
						<div class="invalid-feedback">{{errors[`${Station.passportKeys.serviceUnit.self}.${Station.passportKeys.serviceUnit.unitVersion}`]}}</div>
					</div>
				</div>
				<div class="row form-row">
					<div class="form-group col-auto mt-2">
						<label>Порт сервісного модуля&nbsp;*</label>
						<Field
							:name="`${Station.passportKeys.serviceUnit.self}.${Station.passportKeys.serviceUnit.unitPort}`"
							type="number"
							class="form-control form-control-sm no-arrow"
							:class="{ 'is-invalid': errors[`${Station.passportKeys.serviceUnit.self}.${Station.passportKeys.serviceUnit.unitPort}`] }"
						/>
						<div class="invalid-feedback">{{errors[`${Station.passportKeys.serviceUnit.self}.${Station.passportKeys.serviceUnit.unitPort}`]}}</div>
					</div>
				</div>
				<div class="row form-row">
					<div class="form-group col-auto mt-2">
						<label>ModBus адреса сервісного модуля&nbsp;*</label>
						<Field
							:name="`${Station.passportKeys.serviceUnit.self}.${Station.passportKeys.serviceUnit.unitModbusAddr}`"
							type="number"
							class="form-control form-control-sm no-arrow"
							:class="{ 'is-invalid': errors[`${Station.passportKeys.serviceUnit.self}.${Station.passportKeys.serviceUnit.unitModbusAddr}`] }"
						/>
						<div class="invalid-feedback">{{errors[`${Station.passportKeys.serviceUnit.self}.${Station.passportKeys.serviceUnit.unitModbusAddr}`]}}</div>
					</div>
				</div>

				<!-- Erros {{ errors }} <br> -->
				<!-- Values {{ formValues }} -->

				<div class="row form-row my-3">
					<span class="form-text text-decoration-underline">
						*&nbsp;поля обов'язкові для заповнення
					</span>
				</div>

				<div class="row form-row my-3">
					<span class="form-text fst-italic">
						<span 
							v-if="executionResultMessage.length > 0"
							class="fs-5"
							:class="{'text-success': executionOk, 'text-danger': !executionOk}"
						>
							{{ executionResultMessage }}
						</span>
					</span>
				</div>
				
				<div class="row form-row mt-5">
					<div class="form-group col-auto">&nbsp;</div>

					<div class="form-group col-auto ms-auto me-2">
						<button
							type="button"
							class="btn btn-secondary btn-sm mx-2"
							@click="onCancel"
						>
							Відмінити
						</button>
					</div>
					<div class="form-group col-auto me-0">
						<button
							type="submit"
							class="btn btn-primary btn-sm"
							:disabled="!meta.valid"
						>
							Створити
						</button>
					</div>
				</div>
			</Form>
			</div>
		</div>
	</div>
</div>
</template>


<script>
import UnitIcon from '@/components/Icons/UnitIcon.vue'
import { Form, Field, } from 'vee-validate'
import { Modal } from "bootstrap"
import { useAccontStore } from '@/stores/AccountStore'
import { nameRegex } from "@/models/objectPrototype.js"
import { Station } from '@/models/station.js'
import { PowerUnit } from '@/models/powerUnit.js'
import { ServiceUnit } from '@/models/serviceUnit'
import { ModemUnit } from '@/models/modemUnit.js'
import { RESOURCE_NAMES,
	readResources, createResourceItem,
} from '@/api/api'
import { createUuidv4 } from '@/helpers'
// Validation
// https://jasonwatmore.com/post/2020/10/01/vue-3-veevalidate-form-validation-example
// https://github.com/jquense/yup/tree/a58f02d2f6164c46a9757a818eebac582f7a441c#boolean
import * as Yup from 'yup';


export default {
	waitAfterExecuteSuccessMs: 2100,
	wrongInputPromt: 'Не відповідає вимогам',
	requiredPromt: 'Обов\'язкове поле',
	overMinLen: 'Довжина меньше мінімальної',
	overMaxLen: 'Довжина більше максимальної',
	overMinPromt: 'Значення меньше мінімального',
	overMaxPromt: 'Значення більше максимального',

	components: {
		UnitIcon,
		Form,
		Field,
	},

	props: {
	},

	emits: {
		created: null,
		close: null,
	},

	setup() {
		const accountStore = useAccontStore()

		return {
			accountStore,
			Station,
			PowerUnit,
			ServiceUnit,
			ModemUnit,
		}
	},

	data() {
		const schema = Yup.object().shape({
			name: Yup.string()
				.typeError(this.$options.wrongInputPromt)
				.required(this.$options.requiredPromt)
				.min(4, this.$options.overMinLen)
				.max(60, this.$options.overMaxLen)
				.matches(nameRegex, this.$options.wrongInputPromt),
			short_name: Yup.string()
				.typeError(this.$options.wrongInputPromt)
				.notRequired()
				.nullable()
				.min(1, this.$options.overMinLen)
				.transform((value) => (value ? value : null)) // if empty string
				.max(24, this.$options.overMaxLen)
				.matches(nameRegex, this.$options.wrongInputPromt),
			org_id: Yup.string()
				.typeError(this.$options.wrongInputPromt)
				.required(this.$options.requiredPromt),
			ip: Yup.string()
				.typeError(this.$options.wrongInputPromt)
                .required(this.$options.requiredPromt)
				.min(7, this.$options.overMinLenPromt)
				.max(15, this.$options.overMaxLenPromt)
				.matches(/(([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])/,
					'Може містити тільки IPv4 адресу')
				.notOneOf(['127.0.0.1'], 'Адреса 127.0.0.1 заборонена'),
			modem_unit: Yup.object().shape({
				modem_unit_version: Yup.string()
					.typeError(this.$options.wrongInputPromt),
					//.required(this.$options.requiredPromt),
				modem_unit_port: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(1, this.$options.overMinPromt)
					.max(65535, this.$options.overMaxPromt)
					// Port is required only when modem unit is present
					.when('modem_unit_version', {
						is: (val) => val == ModemUnit.versions.unknown || val == undefined,
						//then: (schema) => schema,
						otherwise: (schema) => schema.required(this.$options.requiredPromt),
					}),
				modem_unit_modbus_addr: Yup.number()
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(1, this.$options.overMinPromt)
					.max(255, this.$options.overMaxPromt)
					// ModBus address is required only when service unit is present
					.when('modem_unit_version', {
						//is: ModemUnit.versions.unknown,
						is: (val) => val == ModemUnit.versions.unknown || val == undefined,
						//then: (schema) => schema,
						otherwise: (schema) => schema.required(this.$options.requiredPromt),
					}),
			}),
			power_unit:  Yup.object().shape({
				unit_version: Yup.string()
					.typeError(this.$options.wrongInputPromt)
					.required(this.$options.requiredPromt),
				unit_port: Yup.number()
					// Not require port for list of module types
					.when('unit_version', {
						is: (ver) => { return [PowerUnit.versions.unknown, PowerUnit.versions.monitoring].includes(ver) },
						then: () => Yup.number(),
						otherwise: () => Yup.number().required(this.$options.requiredPromt),
					})
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(1, this.$options.overMinPromt)
					.max(65535, this.$options.overMaxPromt),
				unit_modbus_addr: Yup.number()
					// Not require addr for list of module types
					.when('unit_version', {
						is: (ver) => { return [PowerUnit.versions.unknown, PowerUnit.versions.monitoring].includes(ver) },
						then: () => Yup.number(),
						otherwise: () => Yup.number().required(this.$options.requiredPromt),
					})
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(1, this.$options.overMinPromt)
					.max(255, this.$options.overMaxPromt),
			}),

			service_unit:  Yup.object().shape({
				unit_version: Yup.string()
					.typeError(this.$options.wrongInputPromt)
					.required(this.$options.requiredPromt),
				unit_port: Yup.number()
					// Not require port for list of module types
					.when('unit_version', {
						is: (ver) => { return [ServiceUnit.versions.unknown].includes(ver) },
						then: () => Yup.number(),
						otherwise: () => Yup.number().required(this.$options.requiredPromt),
					})
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(1, this.$options.overMinPromt)
					.max(65535, this.$options.overMaxPromt),
				unit_modbus_addr: Yup.number()
					// Not require addr for list of module types
					.when('unit_version', {
						is: (ver) => { return [ServiceUnit.versions.unknown].includes(ver) },
						then: () => Yup.number(),
						otherwise: () => Yup.number().required(this.$options.requiredPromt),
					})
					.typeError(this.$options.wrongInputPromt)
					.integer(this.$options.onlyIntegersPromt)
					.min(1, this.$options.overMinPromt)
					.max(255, this.$options.overMaxPromt),
			}),
		});

		return {
			// modal component object
			modal: null,
			handleHidePrevented: null,
			// Update flag
			isCreate: false,
			//------------------ Form
			schema,
			formValues: {},
			organizations: [],
			//------------------
			//  
			executionResultMessage: '',
			executionOk: null,
		}
	},

	async created() {
		this.fillDefaultValues()

		// Read organization depend on user organization role
		if (this.accountStore.isPrimary) {
			// Read all organizations
			this.organizations = await readResources(
				RESOURCE_NAMES.organizations,
				this.accountStore.userLogin,
				this.accountStore.userPassword,
			)
		} else {
			// Read only station organization
			//console.log("organization", this.accountStore.organization)
			this.organizations = [this.accountStore.organization,]
			// Preset organization
			this.formValues.org_id = this.accountStore.organization._id
		}
	},

	async mounted() {
		// Get modal object
		this.modal = new Modal(this.$refs.modalRef)

		this.handleHidePrevented = () => {
			this.close(false)
		}

		// This event is fired when the modal is shown, its backdrop is static
		// and a click outside of the modal is performed. The event is also
		// fired when the escape key is pressed and the keyboard option is set to false.
		this.$refs.modalRef.addEventListener('hidePrevented.bs.modal', this.handleHidePrevented)

		// Show modal popup
		this.modal.show()
	},

	beforeUnmount() {
		// Remove event listener which created in mounted()
		this.$refs.modalRef.removeEventListener('hidePrevented.bs.modal', this.handleHidePrevented)
	},

	methods: {
		fillDefaultValues() {	
			this.formValues[Station.passportKeys.powerUnit.self] = {
				[Station.passportKeys.powerUnit.unitPort]: 7771,
				[Station.passportKeys.powerUnit.unitModbusAddr]: 1
			}
			
			this.formValues[Station.passportKeys.serviceUnit.self] = {
				[Station.passportKeys.serviceUnit.unitPort]: 7771,
				[Station.passportKeys.serviceUnit.unitModbusAddr]: 251,
			}

			this.formValues[Station.passportKeys.modemUnit.self] = {
				[Station.passportKeys.modemUnit.unitVersion]: ModemUnit.versions.autodetect,
				[Station.passportKeys.modemUnit.unitPort]: 7770,
				[Station.passportKeys.modemUnit.unitModbusAddr]: 250,
			}

			this.formValues[Station.passportKeys.electricMeter.self] = {}
		},

		onCancel() { this.close(false); /*console.log("cancel")*/ },

		onSubmit(values) {
			// display form values on success
			//console.log("Form: ", values);

			// Update form values
			this.formValues = values

			this.create()
		},

		// Close popup
		close(isTimeout=false) {
			const emit = this.isCreate ? 'created' : 'close'
			//console.log(`Close, emit=${emit}`)

			if (isTimeout) {
				setTimeout(
					() => {
						this.modal.hide()
						this.$emit(emit)
					},
					this.$options.waitAfterExecuteSuccessMs
				);
			} else{
				this.modal.hide()
				this.$emit(emit)
			}
		},

		// Create station and close popup
		async create() {
			this.executionResultMessage = ''

			let payload = { ... this.formValues }
			payload[Station.passportKeys.metricsId] = createUuidv4()
			payload[Station.passportKeys.creatorId] = this.accountStore.userId

			// Request server to create station
			createResourceItem(
				RESOURCE_NAMES.stationPassports,
				this.accountStore.userLogin,
				this.accountStore.userPassword,
				payload
			).then((/*result*/) => {
				//console.log("create station result = ", result)
				this.executionResultMessage = `Станцію створено.`
				this.executionOk = true
				this.isCreate = true
				this.close(true)
			}).catch(err => {
				console.error("on create station", err)
				this.executionResultMessage = 
					`Станцію не створено: сервер повернув помилку.`
				this.executionOk = false
			})
		},
	},

	computed: {},
};
</script>


<style scoped>
.input-min-width {
	min-width: 64ch;
}

/* Remove arrows from input Chrome, Safari, Edge, Opera */
input.no-arrow::-webkit-outer-spin-button,
input.no-arrow::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* Remove arrows from input Firefox */
input[type=number].no-arrow {
	-moz-appearance: textfield;
	appearance: textfield;
}
</style>
	